var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.canId}},[_c('p',{staticClass:"text-center card-text"},[_vm._v(_vm._s(_vm.data.devcName))]),_c('img',{staticStyle:{"height":"201px","width":"100%"},attrs:{"src":_vm.logo}}),_c('p',{staticClass:"text-right card-text"},[_vm._v(_vm._s(_vm.data.devcUpdatedTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }